import type { Tour } from '@/types/tour'

type TourNameLike = Pick<Tour, 'name' | 'collectionName' | 'customName'>

export function getEffectiveTourName(tour: TourNameLike): string {
  const collectionName = tour.collectionName?.trim()
  if (collectionName) return collectionName
  return tour.name ?? ''
}

export function hasCollectionNameOverride(tour: TourNameLike): boolean {
  const globalName = tour.name?.trim()
  if (!globalName) return false

  const effectiveName = getEffectiveTourName(tour).trim()
  if (!effectiveName) return false

  return effectiveName !== globalName
}

export function getTourGlobalNameSubtitle(tour: TourNameLike): string | null {
  if (!hasCollectionNameOverride(tour)) return null

  const globalName = tour.name?.trim()
  if (!globalName) return null

  const effectiveName = getEffectiveTourName(tour).trim()
  if (!effectiveName || effectiveName === globalName) return null

  return globalName
}

export function getWorkspaceTourDownloadName(tour: TourNameLike): string {
  const globalName = tour.name?.trim() || 'tour'
  const customName = tour.customName?.trim()
  if (!customName) return globalName

  const effectiveName = getEffectiveTourName(tour).trim()
  if (!effectiveName) return globalName

  return `${effectiveName} – ${globalName}`
}
